// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"701e0c57b03ded017645","678":"21977502fefc1d69f277"}[chunkId] + ".js";
};